import * as React from 'react';
import { FileUpload, RadioButton, Textarea, TextInput } from "soprasteria-ui-library";
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { useAuth } from '../../../../App';
import { OrthodonticLkgCfPatientExtensionAdministrationApi } from '../../../../api/OrthodonticLkgCfPatientExtensionAdministrationApi';
import { IOrthodonticLkgCfPatientExtension } from '../../../../models/IOrthodonticLkgCfPatientExtension';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { megaBytesToBytes } from '../../../../helpers/FileHelper';
import { OrthodonticLkgCfPatientExtensionApi } from '../../../../api/OrthodonticLkgCfPatientExtensionApi';
import { dateTimeToDateString } from '../../../../helpers/DateHelper';
import { LibrettoFileUpload } from '../../../FileUpload/LibrettoFileUpload';

interface IOrthodonticLkgCfPatientExtensionInputs {
    orthodonticLkgCfPatientExtension?: IOrthodonticLkgCfPatientExtension;
    patientId: number;
}

export const OrthodonticLkgCfPatientExtensionInputs: React.FunctionComponent<IOrthodonticLkgCfPatientExtensionInputs> = ({ orthodonticLkgCfPatientExtension, patientId }) => {

    const auth = useAuth();
    const api = new OrthodonticLkgCfPatientExtensionAdministrationApi(auth);
    const orthodonticLkgCfPatientExtensionApi = new OrthodonticLkgCfPatientExtensionApi(auth);
    const [orthodonticLkgCfPatientTypes, setOrthodonticLkgCfPatientTypes] = React.useState<IListItem[]>();
    const [orthodonticLkgCfPatientType, setOrthodonticLkgCfPatientType] = React.useState<string>();

    React.useEffect(() => {
        getOrthodonticLkgCfPatientTypes();
    }, [])

    React.useEffect(() => {
        if (orthodonticLkgCfPatientExtension === undefined) {
            getOrthodonticLkgCfPatientType();
        }
    }, [])

    const getOrthodonticLkgCfPatientTypes = () => {
        if (orthodonticLkgCfPatientExtension === undefined) {
            api.getOrthodonticLkgCfPatientTypes((data) => {
                const types = data.map<IListItem>((type) => { return { text: type.description, value: type.patientTypeId.toString() } });
                setOrthodonticLkgCfPatientTypes(types);
            });
        }
    }

    const downloadDocument = (librettoFileId: number, fileName?: string) => {
        orthodonticLkgCfPatientExtensionApi.downloadOrthodonticLkgCfPatientExtensionAttachment(librettoFileId, fileName,
            (error) => {
                alert(error);
            });
    }

    const getOrthodonticLkgCfPatientType = () => {
        api.getOrthodonticLkgCfPatientType(patientId, (data) => {
            setOrthodonticLkgCfPatientType(data.description)
        });
    }

    return (
        <div className="row">
            <h5 className="col-12">Information om ansökan</h5>
            {
                !orthodonticLkgCfPatientType && orthodonticLkgCfPatientExtension === undefined ?
                    <div className="col-6 row">
                        <div className="col-4">
                            <label>Patienttyp:</label>
                        </div>
                        <div className="col-8">
                            {
                                orthodonticLkgCfPatientTypes?.map((type, key) =>
                                    <RadioButton name="orthodonticLkgCfPatientTypeId" key={key} id={`orthodonticLkgCfPatientTypeId${key}`} label={type.text} value={type.value} inlineLabel required />
                                )
                            }
                        </div>
                    </div>
                    :
                    <div className="col-6 ">
                        <TextInput name="orthodonticLkgCfPatientTypeIdReadonly" label="Patienttyp" defaultValue={orthodonticLkgCfPatientExtension === undefined ? orthodonticLkgCfPatientType : orthodonticLkgCfPatientExtension.orthodonticLkgCfPatientType} readonly inlineLabel />
                    </div>
            }
            <div className="col-6">
                {
                    orthodonticLkgCfPatientExtension ?
                        <TextInput name="statusReadonly" label="Status" defaultValue={orthodonticLkgCfPatientExtension.orthodonticLkgCfPatientExtensionStatus} inlineLabel required readonly />
                        : null
                }
            </div>
            <div className="col-6">
                <Textarea name="reason" label="Motivering" inlineLabel required={orthodonticLkgCfPatientExtension === undefined} rows={7} defaultValue={orthodonticLkgCfPatientExtension?.reason} readonly={orthodonticLkgCfPatientExtension !== undefined} />
            </div>
            <div className="col-6">
                {
                    orthodonticLkgCfPatientExtension ?
                        <TextInput name="regDateReadonly" label="Skickad" defaultValue={dateTimeToDateString(orthodonticLkgCfPatientExtension.regDate)} inlineLabel readonly />
                        : null
                }
            </div>
            {
                orthodonticLkgCfPatientExtension?.orthodonticLkgCfPatientExtensionDecision ?
                    <>
                        <div className="col-6">
                            <TextInput name="decisionReadonly" label="Beslut" defaultValue={orthodonticLkgCfPatientExtension.orthodonticLkgCfPatientExtensionDecision} inlineLabel required readonly />
                        </div>
                        {
                            orthodonticLkgCfPatientExtension.orthodonticLkgCfPatientExtensionDecisionReason ?
                                <>
                                    <div className="col-6">
                                        <TextInput name="decisionReasonReadonly" label="Beslutsmotivering" defaultValue={orthodonticLkgCfPatientExtension.orthodonticLkgCfPatientExtensionDecisionReason} inlineLabel required readonly />
                                    </div>
                                </>
                                : null
                        }
                    </>
                    : null
            }
            {
                orthodonticLkgCfPatientExtension === undefined ?
                    <div className="col-12">
                        <LibrettoFileUpload isEditable={false} attachmentCategories={undefined} />
                    </div>
                    : null
            }
            {
                orthodonticLkgCfPatientExtension?.attachments && orthodonticLkgCfPatientExtension?.attachments.length > 0 ?
                    <div className="col-12 row">
                        <label className="col-2">Uppladdade dokument:</label>
                        <div className="col-10">
                            <div className="row">
                                <h6 className="col-10">Filer</h6>
                                <h6 className="col-2">Ladda ner</h6>
                            </div>
                            <ul className="list-no-styling document-download-list">
                                {
                                    orthodonticLkgCfPatientExtension.attachments.map((file, index) =>
                                        <li key={index} className="row" onClick={() => downloadDocument(file.orthodonticLkgCfPatientExtensionAttachmentId, file.name)} title={`Ladda ner ${file.name}`}>
                                            <div className="col-12 download">
                                                <div className="row">
                                                    <p className="col-10">{file.name}</p>
                                                    <span className="col-2 download-icon"><button onClick={(e) => e.preventDefault()}><FontAwesomeIcon icon={faDownload} /></button></span>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                    : null
            }
        </div >
    )
}